import React, { useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";

export function canRecordCommissionRefund(snapshot) {
  return ["held", "awaiting_mapping", "complete"].includes(snapshot?.status) &&
    Number(snapshot?.source_amount) > 0 &&
    !snapshot?.payment?.refunded_at &&
    !snapshot?.refunded_at;
}

export default function CommissionRefundModal({ show, snapshot, saving, onHide, onSubmit }) {
  const [reason, setReason] = useState("");
  const [refundReference, setRefundReference] = useState("");
  const [confirmedFullRefund, setConfirmedFullRefund] = useState(false);
  const submitLock = useRef(false);

  const close = () => {
    if (saving) return;
    setReason("");
    setRefundReference("");
    setConfirmedFullRefund(false);
    onHide();
  };

  const submit = async (event) => {
    event.preventDefault();
    if (submitLock.current || saving || !confirmedFullRefund || !reason.trim() || !refundReference.trim()) return;
    submitLock.current = true;
    try {
      const succeeded = await onSubmit({ reason: reason.trim(), refund_reference: refundReference.trim() });
      if (succeeded !== false) {
        setReason("");
        setRefundReference("");
        setConfirmedFullRefund(false);
      }
    } finally {
      submitLock.current = false;
    }
  };

  return (
    <Modal show={show} onHide={close} centered>
      <Modal.Header closeButton={!saving}>
        <Modal.Title>Record full refund</Modal.Title>
      </Modal.Header>
      <form onSubmit={submit}>
        <Modal.Body>
          <div className="alert alert-warning">
            This records a full refund for the original received amount of <strong>৳{snapshot?.source_amount}</strong>. It does not initiate or transfer money. Partial refunds are not supported here.
          </div>
          <label className="form-label" htmlFor="commission-refund-reason">Reason</label>
          <textarea id="commission-refund-reason" className="form-control mb-3" value={reason} onChange={(event) => setReason(event.target.value)} required />
          <label className="form-label" htmlFor="commission-refund-reference">External refund reference</label>
          <input id="commission-refund-reference" className="form-control mb-3" value={refundReference} onChange={(event) => setRefundReference(event.target.value)} required />
          <div className="form-check">
            <input id="commission-refund-confirm" className="form-check-input" type="checkbox" checked={confirmedFullRefund} onChange={(event) => setConfirmedFullRefund(event.target.checked)} />
            <label className="form-check-label" htmlFor="commission-refund-confirm">I confirm the full amount has already been refunded</label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={close} disabled={saving}>Cancel</Button>
          <Button type="submit" variant="danger" disabled={saving || !confirmedFullRefund || !reason.trim() || !refundReference.trim()}>
            {saving ? "Recording…" : "Record refund"}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
